import actions from "./actions";

const initState = {
  subjects: null,
  subjectsAutoComplete: null,
  key: null,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_SUBJECTS_SUCCESS:
      return {
        ...state,
        subjects: action.subjects,
      };

    case actions.FETCH_SUBJECTS_AUTO_COMPLETE_SUCCESS:
      return {
        ...state,
        subjectsAutoComplete: action.subjects,
      };

    case actions.SET_FILTER:
      return {
        ...state,
        key: action.key,
      };

    case actions.RESET:
      return {
        ...state,
        subjects: null,
      };

    default:
      return state;
  }
}
